/*********************
 *  LOCAL STORAGE    *
 *********************/

export const LS_MAIN_NAV_OPEN = 'main.nav.open';
export const LS_CARE_SERVICE_RESULT = 'careService.result';
export const LS_TASK_SCHEDULER_INFO_BANNER = 'taskScheduler.infoBanner';
export const LS_CARE_LEVEL_ANALYSIS_INFO_BANNER = 'careLevelAnalysis.infoBanner';
export const LS_PROFILE_INFO_BANNER = 'profile.infoBanner';
export const LS_CAREPROFILE_INFO_BANNER = 'careProfile.infoBanner';
export const LS_PFLEGELEISTUNGSFINDER_INFO_BANNER = 'pflegeleistungsfinder.infoBanner';
export const LS_PFLEGELEISTUNGEN_INFO_BANNER = 'pflegeleistungen.infoBanner';
export const LS_APPLICATIONS_INFO_BANNER = 'applications.infoBanner';
export const LS_CARE_LEVEL_CALCULATOR_NEWSLETTER_TOKEN = 'careLevelCalculator.newsletter';
export const LS_CARE_LEVEL_CALCULATOR_JWT = 'careLevelCalculator.jwt';
export const LS_BI_TRACKING_REFERRER = 'biReferrer.tracking';
export const LS_BI_TRACKING_CID = 'biCid.tracking';
export const LS_BI_TRACKING_LANDINGPAGEREFERRER = 'biLandingPageReferrer.tracking';

/*********************
 *  SESSION STORAGE    *
 *********************/

export const SS_CARE_LEVEL_CALCULATOR_PREWIZARD_STEP2_RELOADED =
  'careLevelCalculator.preWizard.step2Reloaded';

/*********************
 *      COOKIES      *
 *********************/
